export class ProjectStatus {
    constructor(public projectStatusCode: number, public projectStatusName: string) {}

    public static fromAny(item: any): ProjectStatus | null {
        if (!item) {
            return null;
        }
        return new ProjectStatus(item.projectStatusCode, item.projectStatusName.trim());
    }
}
